import axios from "axios";
import {
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT_METHOD,
  CART_SAVE_SHIPPING_ADDRESS,
} from "../Constants/CartConstants";
import { BASE_URL } from "../Constants/GlobalConstant";

// ADD TO CART
export const addToCart = (id, qty) => async (dispatch, getState) => {
  const { data } = await axios.get(BASE_URL + `/api/products/${id}`);

  dispatch({
    type: CART_ADD_ITEM,
    payload: {
      product: data._id,
      name: data.name,
      image: data.image,
      price: data.price,
      mrp_price: data.mrp_price,
      countInStock: data.countInStock,
      group: data.group,
      qty,
      max_order: data?.max_order,
      unit: data?.unit,
    },
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
  const tempItem = JSON.parse(localStorage.getItem("cartItems"));
  const associativeArray = tempItem.reduce((acc, item) => {
    acc[item.product] = item.qty;
    return acc;
  }, {});
  localStorage.setItem("cartItemArray", JSON.stringify(associativeArray));

};

// REMOVE PRODUCT FROM CART
export const removefromcart = (id) => (dispatch, getState) => {
  dispatch({
    type: CART_REMOVE_ITEM,
    payload: id,
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
  const tempItem = JSON.parse(localStorage.getItem("cartItems"));
  const associativeArray = tempItem.reduce((acc, item) => {
    acc[item.product] = item.qty;
    return acc;
  }, {});
  localStorage.setItem("cartItemArray", JSON.stringify(associativeArray));
};

// SAVE SHIPPING ADDRESS
export const saveShippingAddress = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_SHIPPING_ADDRESS,
    payload: data,
  });

  localStorage.setItem("shippingAddress", JSON.stringify(data));
};

// SAVE PAYMENT METHOD
export const savePaymentMethod = (data) => (dispatch) => {
  dispatch({
    type: CART_SAVE_PAYMENT_METHOD,
    payload: data,
  });
  localStorage.setItem("paymentMethod", data);
};
